import React, {useEffect, useState} from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";
import {List} from "react-virtualized";

import {customerInterface, employeeInterface} from "./assignQuoteInterfaces";
import {usePrevious} from "../../../misc/helperHooks";
import UiIcon from "../../ui/icons/uiIcon";
// import LoadingSpinner from "../../ui/loadingSpinner";

const AssignQuoteVirtualizedList = (props) => {

  const {renderList, selectEntity, activeEntity, noEntitiesFound, title, contentDimensions, errorMessage,
    hideEmployeesColumn} = props;
  const [scrollToIndex, setScrollToIndex] = useState(0);
  const prevEntity = usePrevious(activeEntity);

  useEffect(() => {
    if (activeEntity && !prevEntity) {
      let scrollToIn = renderList.findIndex(item => item.id === activeEntity.id)
      if (scrollToIn > -1) {
        setScrollToIndex(scrollToIn + 3);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeEntity]);

  const listWidth = contentDimensions && contentDimensions.width
    ? hideEmployeesColumn
      ? contentDimensions.width - 10
      : (contentDimensions.width / 2) - 10
    : 320; // 10 is padding
  const listHeight = contentDimensions && contentDimensions.height ? contentDimensions.height - 15 : 245; // 15 is title

  const listSettings = {
    width: listWidth,
    height: listHeight,
    rowHeight: 40,
    overscanRowCount: 6,
    rowCount: renderList.length,
    showScrollingPlaceholder: false,
    useDynamicRowHeight: false,
  }

  const rowRenderer = ({index, key, style}) => {
    const customer = renderList[index];
    return (
      <li className="ass-list__item" style={style} key={key}>
        <div className={"ui-checkbox ui-checkbox--small"
        + (activeEntity && (customer.id === activeEntity.id) ? " ui-checkbox--checked-svg" : "")}
              onClick={() => selectEntity(customer)}>
          <div className="ui-checkbox__svg">
            <UiIcon icon="checkmark"/>
          </div>
        </div>
        <span className="ui-checkbox__label" onClick={() => selectEntity(customer)}>
          {customer.fullName} {customer.email ? <span className="secondary">({customer.email})</span> : null}
        </span>
      </li>
    );
  }

  const noRowsRenderer = () => <div className={"ass-list"}><FormattedMessage id={noEntitiesFound}/></div>;

  return (
    <div className="ass-content__cell">
      <div className="ass-title">
        <span className="ass-title__text"><FormattedMessage id={title}/></span>
        {errorMessage ? <span className="ass-title__error"><FormattedMessage id={errorMessage}/></span> : null}
      </div>
      <List
        // ref="List"
        className={"ass-list"}
        width={listSettings.width}
        height={listSettings.height}
        overscanRowCount={listSettings.overscanRowCount}
        rowCount={listSettings.rowCount}
        rowHeight={listSettings.rowHeight}
        rowRenderer={rowRenderer}
        noRowsRenderer={noRowsRenderer}
        scrollToIndex={scrollToIndex || 0}
      />
    </div>
  )
};

AssignQuoteVirtualizedList.propTypes = {
  renderList: PropTypes.array.isRequired,
  selectEntity: PropTypes.func.isRequired,
  activeEntity: PropTypes.oneOfType([
    PropTypes.shape(customerInterface),
    PropTypes.shape(employeeInterface)
  ]),
  title: PropTypes.string.isRequired,
  errorMessage: PropTypes.string,
  noEntitiesFound: PropTypes.string.isRequired,
  contentDimensions: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
}

export default injectIntl(AssignQuoteVirtualizedList)
